import Api from '@/services/api.js';

export default {
  addProjectTip(details) {
    return Api.post('projectTips/', details);
  },
  getAllProjectTips() {
    return Api.get('projectTips/');
  },
  deleteProjectTip(projectTip) {
    return Api.delete(`projectTips/${projectTip}`);
  },
  updateProjectTip(projectTip) {
    var projectTipId = projectTip.id;
    return Api.put(`projectTips/${projectTipId}`, projectTip);
  },
  getProjectTipsById(id, type) {
    if (type == 'project') {
      return this.getProjectTipsByProject(id)
    } else {
      return this.getProjectTipsByTip(id)
    }
  },
  getProjectTipsByProject(id) {
    return Api.get('projectTips/byProject/' + id);
  },
  getProjectTipsByTip(id) {
    return Api.get('projectTips/byTip/' + id);
  },
}